import { configureStore } from '@reduxjs/toolkit';
import appContextReducer from './header/reducer';
import nodeMenuReducer from './data-animator/right-side-menu';
import subsScribeerReducer, { addSubscribers, setSubscribers } from './subscriber'

import sidebarReducer from './sidebar/reducer'
const store = configureStore({
	reducer: {
		headerContext: appContextReducer,
		nodeMenuContext: nodeMenuReducer,
		subscribeContext: subsScribeerReducer,
		sidebarContext:sidebarReducer
	}
});

const restoreDataFromLocal = () => {
	const userInfo = localStorage.getItem('user_info');
	// const accessToken = localStorage.getItem('access_token');
	if (userInfo) {
		// const parsed: any = JSON.parse(userInfo);
		// store.dispatch(setUserContext({
		// 	isAuthenticated: accessToken ? true : false,
		// 	userInfo: parsed
		// }));
	}

	const subscribers = localStorage.getItem('subscribers')
	if(subscribers){
		store.dispatch(setSubscribers({data: JSON.parse(subscribers)}))
	}
};

restoreDataFromLocal();

export default store;